import { render, staticRenderFns } from "./ServiceMediaRequestAction.vue?vue&type=template&id=2c687c3a&scoped=true"
import script from "./ServiceMediaRequestAction.vue?vue&type=script&lang=js"
export * from "./ServiceMediaRequestAction.vue?vue&type=script&lang=js"
import "./ServiceMediaRequestAction.vue?vue&type=style&index=0&id=2c687c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c687c3a",
  null
  
)

export default component.exports